import { get, post, patch, put, del } from 'aws-amplify/api';
import { Amplify } from 'aws-amplify';
import axios from 'axios';
import { currentPublicSessionCredentials, getAuthenticatedIdToken, sign } from '../helpr/authHelper';

const getEndpoint = (apiName) => {
  try {
    return Amplify.getConfig()?.API?.REST?.[apiName]?.endpoint ?? '';
  } catch {
    return '';
  }
};

class Service {
  constructor(apiName) {
    this.apiName = apiName;
  }

  get = async (path, queryParameters) => {
    try {
      const idToken = await getAuthenticatedIdToken();
      const { body } = await get({
        apiName: this.apiName,
        path,
        options: {
          headers: { idt: idToken },
          queryParams: queryParameters,
        },
      }).response;
      return body.json();
    } catch (err) {
      console.error(`[Service.get] ${this.apiName}${path}`, err);
      throw err;
    }
  };

  post = async (path, queryParameters, body) => {
    const idToken = await getAuthenticatedIdToken();
    const { body: resBody } = await post({
      apiName: this.apiName,
      path,
      options: {
        headers: { idt: idToken },
        queryParams: queryParameters,
        body,
      },
    }).response;
    return resBody.json();
  };

  patch = async (path, queryParameters, body) => {
    const idToken = await getAuthenticatedIdToken();
    const { body: resBody } = await patch({
      apiName: this.apiName,
      path,
      options: {
        headers: { idt: idToken },
        queryParams: queryParameters,
        body,
      },
    }).response;
    return resBody.json();
  };

  delete = async (path, queryParameters, body) => {
    const idToken = await getAuthenticatedIdToken();
    const { body: resBody } = await del({
      apiName: this.apiName,
      path,
      options: {
        headers: { idt: idToken },
        queryParams: queryParameters,
        body,
      },
    }).response;
    return resBody.json();
  };

  put = async (path, queryParameters, body) => {
    const idToken = await getAuthenticatedIdToken();
    const { body: resBody } = await put({
      apiName: this.apiName,
      path,
      options: {
        headers: { idt: idToken },
        queryParams: queryParameters,
        body,
      },
    }).response;
    return resBody.json();
  };

  unsignedPut = (path, file, options) => {
    console.log(path);
    return axios.put(path, file, options);
  };

  unauthenticatedGet = async (path, queryParameters) => {
    const endpoint = getEndpoint(this.apiName);
    const signedHeader = sign(currentPublicSessionCredentials(), 'GET', endpoint, path, queryParameters);
    const { body } = await get({
      apiName: this.apiName,
      path,
      options: {
        headers: signedHeader,
        queryParams: queryParameters,
      },
    }).response;
    return body.json();
  };

  unauthenticatedPost = async (path, queryParameters, body) => {
    const endpoint = getEndpoint(this.apiName);
    const signedHeader = sign(currentPublicSessionCredentials(), 'POST', endpoint, path, queryParameters, body);
    const { body: resBody } = await post({
      apiName: this.apiName,
      path,
      options: {
        headers: signedHeader,
        queryParams: queryParameters,
        body,
      },
    }).response;
    return resBody.json();
  };
}

export default Service;
